import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { SxProps } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { useRootStore } from '../../stores/rootStore';
import { colors } from '../../theme';

export const Footer = () => {
  const country = useRootStore(state => state.country);

  const linkStyle: SxProps = {
    transition: '.2s ease',
    '&:hover': {
      textDecoration: 'underline',
    },
  };

  return (
    <Stack
      bgcolor={colors.black}
      width="100%"
      alignItems="center"
      p={2}
      gap={1}
    >
      <Typography color="white" fontSize={10} align="center">
        © RP Data Pty Limited trading as Cotality (ABN 67 087 759 171) and
        CoreLogic NZ Limited trading as Cotality (NZCN 1129102){' '}
        {new Date().getFullYear()}. All rights reserved.
      </Typography>

      <Stack
        direction="row"
        divider={
          <Divider
            flexItem
            orientation="vertical"
            sx={{ borderColor: 'white' }}
          />
        }
        gap={1}
      >
        <Link to="/terms-and-conditions">
          <Typography color="white" fontSize={10} sx={linkStyle}>
            Terms and Conditions
          </Typography>
        </Link>

        <Link
          to={`https://www.cotality.com/${country}/legal/privacy-policy`}
          target="_blank"
        >
          <Typography color="white" fontSize={10} sx={linkStyle}>
            Privacy Policy
          </Typography>
        </Link>

        <Link to="/contact-us">
          <Typography color="white" fontSize={10} sx={linkStyle}>
            Contact Us
          </Typography>
        </Link>
      </Stack>
    </Stack>
  );
};
